import ServiceExec from '@/common/utils/ServiceExec';
import userApi from '@/common/service/apis/UserApi';

class UserSvc extends ServiceExec {
  /**
   * 유저 로그인
   * @param {Object} params
   * @return {Promise<Object>} data, accessToken
   */
  login(params = {}) {
    return this.post(userApi.login, params)
      .then(response => {
        return {
          data: response.data,
          accessToken: response.headers['kidsyesos_jtw_user_token']
        };
      })
      .catch(error => {
        console.log('login error: ', error);
      });
  }

  /**
   * 유저 상세정보 (개인정보 수정)
   * @param {Number} userNo
   * @return {Promise<Object>} data
   */
  getUserDetail(userNo) {
    return this.patch(userApi.detail(userNo))
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log('getUserDetail error: ', error);
      });
  }

  /**
   * 유저 휴대폰번호 변경
   * @param {{ userNo: Number, phone: Number }} params
   * @return {Promise<Object>} data
   */
  updatePhoneNumber(params = {}) {
    return this.post(userApi.updatePhoneNumber, params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log('updatePhoneNumber error: ', error);
      });
  }

  /**
   * 휴대폰번호 변경 인증번호 요청
   * @param {{phone: Number}} params
   * @return {*}
   */
  reqAuthCode(params = {}) {
    return this.post(userApi.reqAuthCode, params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log('reqAuthNumber error: ', error);
      });
  }

  /**
   * 인증번호 확인 요청
   * @param params params
   * @param {string} params.type 인증코드 타입(FIND, JOIN)
   * @param {number} params.code 인증코드
   * @returns {Promise<Object>} data.code / 1: 성공
   */
  confirmAuthCode(params = {}) {
    return this.get(userApi.confirmAuthCode, params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log('confirmAuthCode error: ', error);
      });
  }

  /**
   * 메인페이지 정보 가져오기
   * @param {Number} userNo
   * @return {Promise<Object>} data
   */
  getMainPageInfo(userNo) {
    return this.get(userApi.main, { userNo })
      .then(response => {
        return {
          data: response.data
        };
      })
      .catch(error => {
        console.log('mainPage error: ', error);
      });
  }

  /**
   * 휴대폰번호 중복체크
   * */
  duplication(params = {}) {
    return this.post(userApi.duplication, params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log('duplication error: ', error);
      });
  }

  /**
   * 회원가입
   * */
  join(params = {}) {
    return this.post(userApi.join, params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log('duplication error: ', error);
      });
  }

  updateIsPush(params = {}) {
    return this.post(userApi.isPushUpdate, params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log('updateIsPush error: ', error);
      });
  }

  /**
   * 아이디 찾기
   * @param {{phone: Number}} params
   * @return {*}
   */
  findId(params = {}) {
    return this.queryPost(userApi.findId, params).then(response => {
      return response.data;
    });
  }

  /**
   * 비밀번호 찾기
   * @param {{phone: Number}} params
   * @return {*}
   */
  findPassword(params = {}) {
    return this.queryPost(userApi.findPassword, params).then(response => {
      return response.data;
    });
  }

  /**
   * 비밀번호 찾기 > 변경
   * @param {{phone: Number}} params
   * @return {*}
   */
  changePassword(params = {}) {
    return this.queryPost(userApi.changePassword, params).then(response => {
      return response.data;
    });
  }

  /**
   * 비밀번호 변경
   * @param params
   * @param {Number} params.userNo 유저(학부모)번호
   * @param {String} params.password 기존 비밀번호
   * @param {String} params.newPassword 신규 비밀번호
   * @return {Promise<Object>} data
   */
  updatePassword(params = {}) {
    return this.post(userApi.updatePassword, params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log('updateIsPush error: ', error);
      });
  }

  logout(params = {}) {
    return this.post(userApi.logout, params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log('updateIsPush error: ', error);
      });
  }
}

export default new UserSvc();
